import * as React from 'react';

const SearchSuggestion = ({ suggestion , targetPath , onClick  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "search-suggestion__item"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "search-suggestion__link",
        href: `${targetPath}${suggestion.query}`,
        onClick: ()=>onClick && onClick(suggestion.objectID, suggestion.position)
        ,
        tabIndex: 0
    }, suggestion.query));
};

export { SearchSuggestion as default };
//# sourceMappingURL=SearchSuggestion.js.map
